export const CellSchema = () => ({
  title: 'Kontakt',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['name', 'funktion', 'image', 'phone', 'mail'],
    },
  ],

  properties: {
    name: {
      title: 'Name',
      type: 'string',
    },
    funktion: {
      title: 'Funktion',
      type: 'string',
    },
    image: {
      title: 'Bild',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    phone: {
      title: 'Telefonnummer',
      type: 'string',
    },
    mail: {
      title: 'E-Mail',
      type: 'string',
    },
  },
  required: [],
});

export const GridSchema = (intl) => ({
  title: 'Schema',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'content',
      title: 'Kontakt hinzu',
      fields: ['cells'],
    },
  ],

  properties: {
    cells: {
      title: 'Kontakte',
      schema: CellSchema(intl),
      widget: 'object_list',
    },
  },
  required: [],
});
